import React, { useCallback, useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import PageTitle from '../shared/PageTitle'
import { createMessage } from '../../utilities/utilities';
import Message from '../shared/Message';
import CustomLoader from '../shared/CustomLoader';
import PatrolLogsTable from '../tables/PatrolLogsTable';
import { allPatrolLogs } from '../../services/patrolLogs';
import { handleError } from '../../utilities/errorHandler';

const PatrolLogs = () => {
    const [ isLoading, setIsLoading] = useState(false);
    const [ patrolLogs, setPatrolLogs ] = useState([]);
    const [ message, setMessage ] = useState({
        text: '',
        variant: '',
        show: false
    });

    const handleCloseMessage = () => {
        setMessage((prevMessage) => ({...prevMessage, show: false}));
    }

    const handleMessage = (variant, text) => {
        setMessage(createMessage(text, variant));
    }

    const getPatrolLogs = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await allPatrolLogs();
            if (response.status === 200){
                setPatrolLogs(response.data);
            } 
        } catch (error) {
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }  
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        getPatrolLogs();
    }, [getPatrolLogs]);


  return (
    <Container fluid>

        <PageTitle
            title='Patrol Logs'
        />

        <Message
            message={message.text}
            variant={message.variant}
            handleClose={handleCloseMessage}
            show={message.show}
        />

        {
            isLoading ? (
                <CustomLoader />
            ) : (
                <PatrolLogsTable
                    patrolLogs={patrolLogs}
                />
            )
        }

    </Container>
  )
}

export default PatrolLogs